module.exports = __webpack_public_path__ + "static/media/recommendation_low_risk.249518ca.svg";